import styled from 'styled-components'

export const Wrap = styled.div`
  margin-top: 0.75rem;
  font-family: ${({ theme }) => theme.monoFont};
  font-size: 0.85rem;
`

export const Label = styled.div`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors('foreground', 0.55)};
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const Window = styled.div`
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.15)};
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  background: ${({ theme }) => theme.colors('chrome')};
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
  flex-wrap: wrap;
`

export const ToggleBtn = styled.button`
  padding: 0.15rem 0.4rem;
  font-family: ${({ theme }) => theme.monoFont};
  font-size: 0.8rem;
  cursor: pointer;
  border: 1px solid ${({ $on, theme }) => $on ? theme.colors('link') : theme.colors('foreground', 0.2)};
  background: ${({ $on, theme }) => $on ? theme.colors('link', 0.2) : theme.colors('background')};
  color: ${({ $on, theme }) => $on ? theme.colors('text') : theme.colors('foreground', 0.45)};
`

export const SmallBtn = styled.button`
  padding: 0.2rem 0.5rem;
  font-family: ${({ theme }) => theme.monoFont};
  font-size: 0.75rem;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.2)};
  background: ${({ theme }) => theme.colors('background')};
  color: ${({ theme }) => theme.colors('foreground', 0.6)};
  &:hover { border-color: ${({ theme }) => theme.colors('danger')}; color: ${({ theme }) => theme.colors('danger')}; }
`

export const AddBtn = styled.button`
  padding: 0.3rem 0.75rem;
  font-family: ${({ theme }) => theme.monoFont};
  font-size: 0.8rem;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors('link', 0.5)};
  background: ${({ theme }) => theme.colors('background')};
  color: ${({ theme }) => theme.colors('link')};
  &:hover { background: ${({ theme }) => theme.colors('link', 0.1)}; }
`

export const HourInput = styled.input`
  width: 50px;
  font-family: ${({ theme }) => theme.monoFont};
  font-size: 0.85rem;
  padding: 0.1rem 0.3rem;
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.2)};
  background: ${({ theme }) => theme.colors('background')};
  color: ${({ theme }) => theme.colors('text')};
`
